<template>
  <div class="newsDetailsPage">
    <head-top :slide="false"></head-top>
    <div class="newsDetailsBox">
      <h2>{{articleInfo.title}}</h2>
      <div class="newsInfoBox">
        <div class="shareTimeBox">
          <div>
            <div class="timeBox">
              <div class="title">
                <span>{{articleInfo.year}}</span>
              </div>
              <span>{{articleInfo.month}}/{{articleInfo.day}}</span>
              <p>{{articleInfo.date}}</p>
            </div>
            <div class="shareBox">
              <div class="title">
                <span>分享</span>
              </div>
              <i class="icon">
                &#xe636;
                <div class="arrow"></div>
                <div class="shareCanvas" ref="shareCanvas"></div>
              </i>
              <i class="icon" @click="onQqFriends">&#xe603;</i>
              <i class="icon" @click="onWeibo">&#xe678;</i>
            </div>
            <div class="heatBox">
              <div class="title"><span>阅读量</span></div>
              <div class="thumbs">{{articleInfo.numVisit}}</div>
              <!-- <div class="thumbs"><i class="icon">&#xe60c;</i> {{articleInfo.numVisit}}</div> -->
              <!-- <div class="thumbs"><i class="icon">&#xe61e;</i> 65461</div> -->
            </div>
          </div>
        </div>
        <div class="newsContentBox">
          <div class="newsContent" v-html="articleInfo.content"></div>
          <div class="sourceBox">
            <p v-if="articleInfo.sourceName">来源：{{articleInfo.sourceName}}</p>
            <p v-if="articleInfo.author">编辑：{{articleInfo.author}}</p>
          </div>
          <!-- <div class="sourceBox">
            <p>来源：新浪新闻</p>
            <p>编辑：黄小编</p>
          </div>-->
          <!-- <div class="likeBox">
            <i class="icon">&#xe60c;</i>
            <p>1110个赞</p>
            <div class="heatBox">
              <div class="thumbs"><i class="icon">&#xe60c;</i> 122</div>
              <div class="thumbs"><i class="icon">&#xe61e;</i> 65461</div>
            </div>
          </div>
          <div class="commentBox">
            <textarea placeholder="说点什么吧..."></textarea>
            <div class="but">
              <button>提交</button>
            </div>
            <div class="commentTitle">
              评论（<span>123</span>条）
            </div>
            <div class="commentList">
              <div class="userImg">
                <img src="https://qn.kemean.cn/upload/201809/06/fcd8a8f5d9074ae497f14cd0e76bbd68">
              </div>
              <div class="commentInfo">
                <div class="userInfo">
                  <div class="name">
                    <span>游客1</span>
                    <p>2018-04-17  14:03</p>
                  </div>
                  <span>回复</span>
                </div>
                <div class="commentText">
                  哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈
                </div>
              </div>
            </div>
          </div> 
          <z-page :total="total" :currentPage="pageSize" @current-change="pageChange" :totalPage="5" :last="false"></z-page>-->
        </div>
      </div>
    </div>
    <foot-guide></foot-guide>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      articleInfo: {}
    };
  },
  created() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      // 获取资讯
      this.$ajax
        .get("api/article/v1/info", {
          objId: this.$route.query.objId
        })
        .then(data => {
          if (data.createTime) {
            data.year = data.createTime.substring(0, 4);
            data.month = data.createTime.substring(5, 7);
            data.day = data.createTime.substring(8, 10);
            data.date = data.createTime.split(" ")[1];
          }
          this.articleInfo = data;
          this.onWeChat();
        });
    },
    //QQ好友分享
    onQqFriends() {
      // 标题
      var title = this.articleInfo.title || "标题";
      // 图片
      var imgUrl =
        this.articleInfo.headImg ||
        "https://qn.kemean.cn/upload/201809/06/logo_a.png";
      // 链接
      var url = window.location.href;
      //简介
      var msg =
        this.articleInfo.introduce ||
        "不知道说点什么，快点进来看看吧！";
      window.open(
        "http://connect.qq.com/widget/shareqq/index.html?url=" +
        url +
        "?sharesource=qzone&title=" +
        title +
        "&pics=" +
        imgUrl +
        "&summary=" +
        msg +
        "&desc="
      );
    },
    //新浪微博分享
    onWeibo() {
      // 标题
      var title = this.articleInfo.title || "标题";
      // 图片
      var imgUrl =
        this.articleInfo.shareImg ||
        "https://qn.kemean.cn/upload/201809/06/logo_a.png";
      // 链接
      var url = window.location.href;
      window.open(
        "http://service.weibo.com/share/share.php?url=" +
        url +
        "?sharesource=weibo&title=" +
        title +
        "&pic=" +
        imgUrl +
        "&appkey=2706825840"
      );
    },
    //微信二维码体验一下
    onWeChat() {
      // 链接
      var url = window.location.href;
      var shareCanvas = this.$refs.shareCanvas;
      new QRCode(shareCanvas, {
        text: url,
        width: 130,
        height: 130,
        colorDark: "#000000",
        colorLight: "#ffffff"
      });
    }
  },
  mounted() { }
};
</script>
<style lang="scss">
@media screen and (min-width: 1200px) {
  .newsDetailsPage {
    padding-top: 76px;
    background-color: #fff;
    .newsDetailsBox {
      max-width: 1200px;
      width: 100%;
      margin: 0 auto;
      padding: 40px 0px;
      h2 {
        font-size: 40px;
        font-weight: bold;
        color: #333333;
      }
      .newsInfoBox {
        display: flex;
        margin-top: 40px;
        .shareTimeBox {
          width: 127px;
          flex-shrink: 0;
          margin-right: 40px;
          > div {
            border-right: 1px solid #e8e8e8;
            padding-right: 36px;
          }
          .title {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            &::after,
            &::before {
              content: "";
              flex: 1;
              border-top: 1px solid #e8e8e8;
            }
            span {
              font-size: 14px;
              color: #666666;
              flex-shrink: 0;
              padding: 0px 5px;
            }
          }
          .timeBox {
            text-align: center;
            height: 160px;
            > span {
              font-size: 30px;
              color: #333333;
              font-style: italic;
            }
            p {
              font-size: 18px;
              color: #333333;
              font-style: italic;
            }
          }
          .shareBox {
            height: 270px;
            display: flex;
            flex-direction: column;
            align-items: center;
            i {
              display: block;
              font-size: 36px;
              color: rgba(218, 218, 218, 0.9);
              line-height: 60px;
              cursor: pointer;
              position: relative;
              &:hover {
                .arrow,
                .shareCanvas {
                  display: block;
                }
              }
              .arrow {
                position: absolute;
                right: -15px;
                top: 50%;
                transform: translateY(-50%);
                border-right: 10px solid #eee;
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
                display: none;
                z-index: 2;
                &::before {
                  content: "";
                  position: absolute;
                  left: 2px;
                  top: 50%;
                  transform: translateY(-50%);
                  border-right: 10px solid #fff;
                  border-top: 8px solid transparent;
                  border-bottom: 8px solid transparent;
                }
              }
              > .shareCanvas {
                position: absolute;
                right: -165px;
                top: 50%;
                transform: translateY(-50%);
                border: 1px solid #eee;
                background-color: #fff;
                border-radius: 4px;
                width: 150px;
                height: 150px;
                padding: 10px;
                display: none;
                img {
                  width: 100%;
                }
              }
            }
          }
          .heatBox {
            .thumbs {
              display: flex;
              padding: 10px 0;
              align-items: center;
              justify-content: center;
              font-size: 14px;
              color: #333333;
              &:nth-child(2) {
                i {
                  font-size: 26px;
                }
              }
              &:nth-child(3) {
                i {
                  font-size: 21px;
                }
              }
              i {
                color: #dadada;
                margin-right: 10px;
              }
            }
          }
        }
        .newsContentBox {
          width: 820px;
          .newsContent {
            font-size: 18px;
            color: #333333;
            line-height: 180%;
            img {
              max-width: 100%;
            }
          }
          .sourceBox {
            margin-top: 30px;
            p {
              font-size: 16px;
              color: #999999;
              line-height: 150%;
            }
          }
          .likeBox {
            display: flex;
            align-items: center;
            flex-direction: column;
            padding-top: 40px;
            padding-bottom: 30px;
            i {
              width: 66px;
              height: 66px;
              border: solid 1px #345a9e;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 28px;
              color: #345a9e;
              cursor: pointer;
            }
            p {
              margin-top: 10px;
              color: #666;
              font-size: 14px;
              display: none;
            }
            .heatBox {
              display: none;
            }
          }
          .commentBox {
            padding-bottom: 20px;
            textarea {
              width: 100%;
              height: 220px;
              border: 1px solid #eee;
              border-radius: 5px;
              padding: 10px;
              resize: none;
            }
            .but {
              display: flex;
              justify-content: flex-end;
              margin-top: 30px;
              button {
                width: 230px;
                height: 40px;
                background-color: #345a9e;
                border-radius: 5px;
                font-size: 14px;
                color: #ffffff;
              }
            }
            .commentTitle {
              padding-bottom: 10px;
              margin-top: 10px;
              font-size: 16px;
              color: #999999;
              span {
                color: #345a9e;
              }
            }
            .commentList {
              padding: 39px 0px 20px 0px;
              display: flex;
              border-top: 1px dashed #eee;
              &.reply {
                padding-left: 75px;
              }
              .userImg {
                width: 70px;
                height: 70px;
                background-color: #e6e6e6;
                flex-shrink: 0;
                margin-right: 29px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .commentInfo {
                .userInfo {
                  display: flex;
                  justify-content: space-between;
                  .name {
                    display: flex;
                    align-items: center;
                    span {
                      font-size: 18px;
                      color: #4d4d4d;
                      margin-right: 19px;
                    }
                    p {
                      font-size: 14px;
                      color: #999999;
                    }
                  }
                  > span {
                    font-size: 16px;
                    color: #345a9e;
                    cursor: pointer;
                  }
                }
                .commentText {
                  margin-top: 27px;
                  font-size: 14px;
                  color: #a6a6a6;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 750px) and (max-width: 1200px) {
  .newsDetailsPage {
    padding-top: 76px;
    background-color: #fff;
    .newsDetailsBox {
      width: 100%;
      padding: 40px 40px;
      max-width: 900px;
      margin: 0 auto;
      h2 {
        font-size: 40px;
        font-weight: bold;
        color: #333333;
      }
      .newsInfoBox {
        margin-top: 40px;
        .shareTimeBox {
          width: 100%;
          flex-shrink: 0;
          margin-bottom: 20px;
          // padding: 0px 10px;
          > div {
            // border-right: 1px solid #e8e8e8;
            padding-right: 36px;
            display: flex;
            align-items: center;
            .title {
              span {
                font-size: 14px;
                color: #999999;
              }
            }
            .timeBox {
              text-align: center;
              display: flex;
              margin-right: 50px;
              > span {
                font-size: 16px;
                color: #999999;
                &::before {
                  content: "/";
                  color: #999999;
                }
              }
              p {
                font-size: 16px;
                color: #999999;
                margin-left: 8px;
              }
            }
            .shareBox {
              display: flex;
              align-items: center;
              margin-right: 50px;
              .title {
                &::after {
                  content: "：";
                }
              }
              i {
                display: block;
                font-size: 22px;
                color: rgba(218, 218, 218, 0.9);
                cursor: pointer;
                margin-left: 10px;
                position: relative;
                &:hover {
                  .arrow,
                  .shareCanvas {
                    display: block;
                  }
                }
                .arrow {
                  position: absolute;
                  bottom: -15px;
                  left: 50%;
                  transform: translateX(-50%);
                  border-bottom: 10px solid #eee;
                  border-left: 8px solid transparent;
                  border-right: 8px solid transparent;
                  display: none;
                  z-index: 2;
                  &::before {
                    content: "";
                    position: absolute;
                    top: 2px;
                    left: 50%;
                    transform: translateX(-50%);
                    border-bottom: 10px solid #fff;
                    border-left: 8px solid transparent;
                    border-right: 8px solid transparent;
                  }
                }
                > .shareCanvas {
                  position: absolute;
                  bottom: -165px;
                  left: 50%;
                  transform: translateX(-50%);
                  border: 1px solid #eee;
                  background-color: #fff;
                  border-radius: 4px;
                  padding: 10px;
                  width: 150px;
                  height: 150px;
                  z-index: 1;
                  display: none;
                  img {
                    width: 100%;
                  }
                }
              }
            }
            .heatBox {
              display: flex;
              align-items: center;
              .title {
                &::after {
                  content: "：";
                }
              }
              .thumbs {
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #999999;
                margin-right: 20px;
                &:nth-child(2) {
                  i {
                    font-size: 22px;
                  }
                }
                &:nth-child(3) {
                  i {
                    font-size: 18px;
                  }
                }
                i {
                  color: #dadada;
                  margin-right: 10px;
                }
              }
            }
          }
        }
        .newsContentBox {
          max-width: 820px;
          .newsContent {
            font-size: 18px;
            color: #333333;
            line-height: 180%;
            img {
              max-width: 100%;
            }
          }
          .sourceBox {
            margin-top: 30px;
            p {
              font-size: 16px;
              color: #999999;
              line-height: 150%;
            }
          }
          // .likeBox {
          //   display: flex;
          //   align-items: center;
          //   flex-direction: column;
          //   padding-top: 40px;
          //   padding-bottom: 30px;
          //   i {
          //     width: 66px;
          //     height: 66px;
          //     border: solid 1px #345a9e;
          //     border-radius: 50%;
          //     display: flex;
          //     align-items: center;
          //     justify-content: center;
          //     font-size: 28px;
          //     color: #345a9e;
          //     cursor: pointer;
          //   }
          //   p {
          //     margin-top: 10px;
          //     color: #666;
          //     font-size: 14px;
          //   }
          // }
          .likeBox {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 4vw;
            padding-bottom: 5vw;
            > i {
              width: 6vw;
              height: 6vw;
              border: solid 1px #345a9e;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 3vw;
              color: #345a9e;
              cursor: pointer;
            }
            p {
              display: none;
            }
            .heatBox {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 5vw;
              .thumbs {
                display: flex;
                align-items: center;
                font-size: 1.8vw;
                color: #999999;
                &:nth-child(1) {
                  margin-right: 4vw;
                  i {
                    font-size: 2.8vw;
                  }
                }
                &:nth-child(2) {
                  i {
                    font-size: 2vw;
                  }
                }
                i {
                  color: #dadada;
                  margin-right: 1vw;
                }
              }
            }
          }
          .commentBox {
            padding-bottom: 20px;
            textarea {
              width: 100%;
              height: 220px;
              border: 1px solid #eee;
              border-radius: 5px;
              padding: 10px;
              resize: none;
            }
            .but {
              display: flex;
              justify-content: flex-end;
              margin-top: 30px;
              button {
                width: 230px;
                height: 40px;
                background-color: #345a9e;
                border-radius: 5px;
                font-size: 14px;
                color: #ffffff;
              }
            }
            .commentTitle {
              padding-bottom: 10px;
              margin-top: 10px;
              font-size: 16px;
              color: #999999;
              span {
                color: #345a9e;
              }
            }
            .commentList {
              padding: 39px 0px 20px 0px;
              display: flex;
              border-top: 1px dashed #eee;
              &.reply {
                padding-left: 75px;
              }
              .userImg {
                width: 70px;
                height: 70px;
                background-color: #e6e6e6;
                flex-shrink: 0;
                margin-right: 29px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .commentInfo {
                .userInfo {
                  display: flex;
                  justify-content: space-between;
                  .name {
                    display: flex;
                    align-items: center;
                    span {
                      font-size: 18px;
                      color: #4d4d4d;
                      margin-right: 19px;
                    }
                    p {
                      font-size: 14px;
                      color: #999999;
                    }
                  }
                  > span {
                    font-size: 16px;
                    color: #345a9e;
                    cursor: pointer;
                  }
                }
                .commentText {
                  margin-top: 27px;
                  font-size: 14px;
                  color: #a6a6a6;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .newsDetailsPage {
    background-color: #fff;
    padding-top: 30px;
    .newsDetailsBox {
      width: 100%;
      padding: 4vw 4vw;
      max-width: 900px;
      margin: 0 auto;
      h2 {
        font-size: 6vw;
        font-weight: bold;
        color: #333333;
      }
      .newsInfoBox {
        margin-top: 4vw;
        .shareTimeBox {
          width: 100%;
          margin-bottom: 2vw;
          > div {
            // border-right: 1px solid #e8e8e8;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            .title {
              display: flex;
              align-items: center;
              span {
                font-size: 3.6vw;
                color: #999999;
              }
            }
            .timeBox {
              text-align: center;
              display: flex;
              align-items: center;
              margin-right: 5vw;
              > span {
                font-size: 3.6vw;
                color: #999999;
                &::before {
                  content: "/";
                  color: #999999;
                  font-size: 3.6vw;
                }
              }
              p {
                font-size: 3.6vw;
                color: #999999;
                margin-left: 0.8vw;
              }
            }
            .shareBox {
              display: flex;
              align-items: center;
              i {
                display: block;
                font-size: 5vw;
                color: rgba(218, 218, 218, 0.9);
                cursor: pointer;
                margin-left: 3vw;
                position: relative;
                &:hover {
                  .arrow,
                  .shareCanvas {
                    display: block;
                  }
                }
                .arrow {
                  position: absolute;
                  bottom: -10px;
                  left: 50%;
                  transform: translateX(-50%);
                  border-bottom: 10px solid #eee;
                  border-left: 8px solid transparent;
                  border-right: 8px solid transparent;
                  display: none;
                  z-index: 2;
                  &::before {
                    content: "";
                    position: absolute;
                    top: 2px;
                    left: 50%;
                    transform: translateX(-50%);
                    border-bottom: 10px solid #fff;
                    border-left: 8px solid transparent;
                    border-right: 8px solid transparent;
                  }
                }
                > .shareCanvas {
                  position: absolute;
                  bottom: -160px;
                  left: 50%;
                  transform: translateX(-50%);
                  border: 1px solid #eee;
                  background-color: #fff;
                  border-radius: 4px;
                  padding: 10px;
                  width: 150px;
                  height: 150px;
                  z-index: 1;
                  display: none;
                  img {
                    width: 100%;
                  }
                }
              }
            }
            .heatBox {
              display: none;
              align-items: center;
              .title {
                display: none;
              }
              .thumbs {
                display: flex;
                align-items: center;
                font-size: 3.6vw;
                color: #999999;
                margin-right: 2vw;
                &:nth-child(2) {
                  i {
                    font-size: 6vw;
                  }
                }
                &:nth-child(3) {
                  i {
                    font-size: 3.4vw;
                  }
                }
                i {
                  color: #dadada;
                  margin-right: 1vw;
                }
              }
            }
          }
        }
        .newsContentBox {
          max-width: 820px;
          .newsContent {
            font-size: 18px;
            color: #333333;
            line-height: 180%;
            img {
              max-width: 100%;
            }
          }
          .sourceBox {
            margin-top: 3vw;
            p {
              font-size: 3.6vw;
              color: #999999;
              line-height: 150%;
            }
          }
          .likeBox {
            display: flex;
            align-items: center;
            padding-top: 4vw;
            padding-bottom: 5vw;
            > i {
              width: 16vw;
              height: 16vw;
              border: solid 1px #345a9e;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 7vw;
              color: #345a9e;
              cursor: pointer;
            }
            p {
              display: none;
            }
            .heatBox {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 5vw;
              .thumbs {
                display: flex;
                align-items: center;
                font-size: 3.4vw;
                color: #999999;
                &:nth-child(1) {
                  margin-right: 4vw;
                  i {
                    font-size: 6vw;
                  }
                }
                &:nth-child(2) {
                  i {
                    font-size: 5vw;
                  }
                }
                i {
                  color: #dadada;
                  margin-right: 1vw;
                }
              }
            }
          }
          .commentBox {
            padding-bottom: 1vw;
            textarea {
              width: 100%;
              height: 22vw;
              border: 1px solid #eee;
              border-radius: 0.5vw;
              padding: 2vw;
              resize: none;
            }
            .but {
              display: flex;
              justify-content: flex-end;
              margin-top: 3vw;
              button {
                width: 30vw;
                height: 10vw;
                background-color: #345a9e;
                border-radius: 1vw;
                font-size: 3.4vw;
                color: #ffffff;
              }
            }
            .commentTitle {
              padding-bottom: 2vw;
              margin-top: 2vw;
              font-size: 3.6vw;
              color: #999999;
              span {
                color: #345a9e;
              }
            }
            .commentList {
              padding: 3.9vw 0px 4vw 0px;
              display: flex;
              border-top: 1px dashed #eee;
              &.reply {
                padding-left: 14vw;
              }
              .userImg {
                width: 14vw;
                height: 14vw;
                background-color: #e6e6e6;
                flex-shrink: 0;
                margin-right: 6vw;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .commentInfo {
                .userInfo {
                  display: flex;
                  justify-content: space-between;
                  .name {
                    display: flex;
                    align-items: center;
                    span {
                      font-size: 4.2vw;
                      color: #4d4d4d;
                      margin-right: 3.2vw;
                    }
                    p {
                      font-size: 3.4vw;
                      color: #999999;
                    }
                  }
                  > span {
                    font-size: 3.8vw;
                    color: #345a9e;
                    cursor: pointer;
                  }
                }
                .commentText {
                  margin-top: 5vw;
                  font-size: 3.6vw;
                  color: #a6a6a6;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
